module.exports = __webpack_public_path__ + "img/banner.6b5b13ab.png";